import {
  CREATE_AGREEMENT_ERROR,
  CREATE_AGREEMENT_SUCCESS,
  DOWNLOAD_AGREEMENT_SUCCESS,
  DOWNLOAD_AGREEMENT_ERROR,
  DOWNLOAD_PDF_AGREEMENT_SUCCESS,
  DOWNLOAD_PDF_AGREEMENT_ERROR,
} from '../../actions/agreement/agreementActionConstants';

import createReducer from '../../utils/createReducer';

const initialState = {
  Agreement: '',
  PDFAgreement: '',
  error: '',
};

export default createReducer(
  {
    [CREATE_AGREEMENT_SUCCESS]: createAgreementSuccess,
    [CREATE_AGREEMENT_ERROR]: createAgreementError,
    [DOWNLOAD_AGREEMENT_SUCCESS]: downloadAgreementSuccess,
    [DOWNLOAD_AGREEMENT_ERROR]: downloadAgreementError,
    [DOWNLOAD_PDF_AGREEMENT_SUCCESS]: downloadPdfAgreementSuccess,
    [DOWNLOAD_PDF_AGREEMENT_ERROR]: downloadPdfAgreementError,
  },
  initialState,
);

function createAgreementSuccess(state, { payload }) {
  return {
    ...state,
    Agreement: payload,
    error: '',
  };
}

function createAgreementError(state, { payload }) {
  return {
    ...state,
    error: payload,
  };
}

function downloadAgreementSuccess(state, { payload }) {
  return {
    ...state,
    Agreement: payload,
    error: '',
  };
}

function downloadAgreementError(state, { payload }) {
  return {
    ...state,
    error: payload,
  };
}

function downloadPdfAgreementSuccess(state, { payload }) {
  return {
    ...state,
    PDFAgreement: payload,
    error: '',
  };
}

function downloadPdfAgreementError(state, { payload }) {
  return {
    ...state,
    error: payload,
  };
}
